@let _floatingConfig = floatingConfig();
@if (_floatingConfig && currentActiveFieldModel()) {
  <!-- Mouse events should not bubble to the preview to not mark any words in the background of the floating element. -->
  <shared-core-expandable-card
    blockMouseEvents
    #dragRef="cdkDrag"
    #fieldExtractionOverlay
    cdkDrag
    floatingElement
    [toggleArea]="'custom'"
    [toggleElement]="toggle"
    [anchor]="_floatingConfig.anchor?.nativeElement"
    [isOpened]="!isPinned()"
    [placement]="'bottom-start'"
    [offsetConfig]="_floatingConfig.offset"
    [flip]="true"
    [(isExpanded)]="isExpanded"
    [enableAutoUpdate]="enableAutoUpdate()"
    (cdkDragStarted)="isDragged.set(true); hasBeenDragged.set(true)"
    (cdkDragEnded)="onDragEnd($event.event)"
    class="!pointer-events-auto fixed z-1000 flex w-[360px] flex-col rounded-2xl bg-white/75 p-4 shadow"
    [ngClass]="{ 'cursor-grab': isDragged() }">
    <shared-core-expandable-card-header class="flex cursor-pointer flex-col">
      <div class="flex flex-row justify-between gap-4">
        <span class="overflow-hidden text-base font-bold text-ellipsis whitespace-nowrap">
          {{ fieldGroupModel()?.label }}: {{ field()?.label?.text }}
        </span>
        <span
          #toggle
          class="material-icons transition-transform"
          [ngClass]="{ 'rotate-180': !isExpanded() }">
          keyboard_arrow_down
        </span>
      </div>
      <div class="flex h-5 items-center">
        <span class="text-error text-xxs">{{ displayError() }}</span>
      </div>
      <app-input
        borderColorHex="#006436"
        [control]="formControl()"
        (valueChange)="onManualInputChange()"
        (mousedown)="$event.stopPropagation()"
        (click)="$event.stopPropagation()" />
    </shared-core-expandable-card-header>
    <shared-core-expandable-card-content class="overflow-hidden">
      <div class="h-4"></div>
      @let showConfirmButton = !!formControl()?.value;
      <div class="grid h-10 gap-4" [ngClass]="showConfirmButton ? 'grid-cols-2' : 'grid-cols-1'">
        <button
          class="bg-secondary text-ci-lightblack w-full rounded-md border border-[#727777] text-xs font-bold text-nowrap"
          (click)="onCancel()">
          NICHT GEFUNDEN
        </button>
        <button
          class="bg-primary text-on-primary flex w-full items-center justify-center gap-2 rounded-md text-xs font-bold text-nowrap"
          [ngClass]="{ hidden: !showConfirmButton }"
          (click)="onConfirm()">
          <img src="@shared/circle-check-solid.svg" loading="lazy" alt="Kreis mit Häkchen Icon" />
          BESTÄTIGEN
        </button>
      </div>
    </shared-core-expandable-card-content>
  </shared-core-expandable-card>
}
